import { accountCheck, RESULTCODE } from '@tencent/vb-web-base/dist/accountTips';
import { useRoute, useRouter } from 'vue-router';
import { baseMixins } from '@common/mixins/baseMixins';
import { checkLimitCreate, GetLoanConfigList } from '@common/core/network/NodeAPI';
import { NO_HONGKONG_IDCARD, NOT_IN_TESLAWHITELIST, ProductType } from '@common/core/help/constant';
import { i18n } from '@tencent/vb-web-base';
import { isFusionBankApp } from '@tencent/vb-web-base-core';
import { useProductConfigs } from '../composables/useProductConfig';
import { useProduct } from '@common/composables/useProduct';
import { useLimit } from '@common/composables/useLimit';
import { useContractKeys } from '@common/composables/useContractKeys';
import { onMounted, reactive } from 'vue';
import { RESIDENCETYPE } from '@loan/vb-node-loan/types';
import { navigator } from '@tencent/vb-app-bridge';
import { checkTeslaWhiteAndOwnerInfo } from '@common/core/network/activityAPI';
import { checkAssociation } from '@common/core/network/umAPI';
import { EnumWhitelistStatus } from '@common/core/interface/IModel';
import { reportStatistics } from '@tencent/vb-web-base';
export function useApply(prodNo, onmountShowLoadingTag = true) {
    const router = useRouter();
    const route = useRoute();
    const productConfig = useProductConfigs();
    const productStore = useProduct();
    const limitStore = useLimit();
    const contractKeysStore = useContractKeys();
    // const productConfig = ref<IProductViewData>();
    // let accountManager: AccountManager;
    const { getT } = i18n;
    const $t = getT();
    let residentType = RESIDENCETYPE.UNKNOW;
    const state = reactive({
        product: productStore.productState,
        seq: '',
    });
    const { showLoading, showModalError, checkIsInstallment, showModal, hideModal, previewContract, closeWindow, checkIsTesla, sleep } = baseMixins();
    const isTesla = checkIsTesla();
    onMounted(async () => {
        try {
            // 获取商品信息
            // const proManager = await ProductManager.getInstance((prodNo as string) || ProductInfoMap.DEFAULT);
            if (onmountShowLoadingTag) {
                showLoading(true);
            }
            // const product = await getProductInfo();
            // state.product = product;
            // accountManager = await AccountManager.init();
        }
        catch (err) {
            showLoading(false);
            const error = err;
            if (error.code !== 401 && error.code !== 1036610001) {
                await showModalError(error.message, error.code);
                closeWindow();
            }
        }
        finally {
            showLoading(false);
        }
    });
    // 用户主动放弃额度 后重新申请弹的提示
    function showCancelTips(expired) {
        showModalError($t('您的贷款申请已取消，贷款服务将会于{expired}再次开放。', { expired }));
    }
    async function goToQuestion(product) {
        try {
            const { acctNo } = limitStore.userInfo;
            const name = product.productTag === ProductType.INSTALLMENT ? 'applyTrial' : 'inviteCode';
            const param = {
                name,
                query: {
                    ...route.query,
                    residentType,
                    accNo: acctNo,
                    seq: state.seq,
                    productTag: product.productTag,
                    ccyCode: product.ccyCode,
                    prodNo: product.proNo,
                    limitMax: product.extInfo.limit_max,
                    limitMin: product.extInfo.limit_min,
                },
            };
            if (route.path === '/teslaRightOverview') {
                // @ts-ignore
                const queryString = new URLSearchParams(Object.entries(param.query)).toString();
                // window.location.href = `https://www.fusionbank.com/h5/walletLoan/app/index.html?${queryString}#/${name}`;
                navigator.invoke(`https://www.fusionbank.com/h5/walletLoan/app/index.html?prodNo=${prodNo}&activeTag=${prodNo}#/inviteCode?${queryString}`, {
                    target: 'web',
                });
                return;
            }
            if (route.path === '/teslaIdentify') {
                return router.replace(param);
            }
            router.push(param);
        }
        catch (err) {
            console.error('err', err);
            const error = err;
            showModalError(error.message, error.code);
        }
    }
    const checkEntryCanApply = async () => {
        if (!isFusionBankApp) {
            return true;
        }
        const entryInfo = await GetLoanConfigList('loan_home_product_V2', '1');
        const configFilter = entryInfo.content?.filter((configItem) => configItem.productNo === prodNo);
        let hasBindWx = false;
        let applyCanUse = true;
        if (configFilter?.length > 0) {
            const configItem = configFilter[0];
            if (configItem.isOffLine === '3') {
                applyCanUse = false;
                if (configItem.whitePackActiveAndInWhite) {
                    applyCanUse = true;
                }
                if (configItem.showWhenWechatBind) {
                    hasBindWx = await checkAssociation();
                    if (hasBindWx) {
                        applyCanUse = true;
                    }
                }
            }
            else if (configItem.isOffLine === '2') {
                applyCanUse = false;
            }
        }
        return applyCanUse;
    };
    const submitApply = async (info) => {
        const res = await accountCheck({
            needAutoLogin: true,
            loginReload: true,
            needActivateModal: true,
            needOpenModal: true,
        });
        if (res.code !== RESULTCODE.SUCCESS) {
            return res.code;
        }
        try {
            const applyCanUse = await checkEntryCanApply();
            if (!applyCanUse) {
                reportStatistics({ evtName: 'applyCanNotUse' });
                await showModal($t('很抱歉，我们暂时未能为您提供服务，请稍后再试'), $t('温馨提示'), '', $t('我知道了'));
                return -1;
            }
            await Promise.all([productStore.refreshProduct(), productConfig.initConfig(), contractKeysStore.refreshContractKeys()]);
            // 如果非永居状态无效,则再查询一次
            if (![RESIDENCETYPE.RESIDENTPERMANENT, RESIDENCETYPE.RESIDENTNOPERMANENT].includes(info.residentType)) {
                await limitStore.refreshLimit();
                info.residentType = limitStore.userInfo.residentType;
            }
            residentType = info.residentType;
            if (info.residentType !== RESIDENCETYPE.RESIDENTPERMANENT && productConfig.config.allowNoReside === '2') {
                await showModal(productConfig.config.applyTips.split('\n'), $t('暂不符合以下之申请资格'), '', $t('我知道了'));
                return -1;
            }
            showLoading(true);
            const { seq } = await checkLimitCreate(prodNo);
            state.seq = seq;
            await checkTeslaOwnerInfo();
            showLoading(false);
            // 分期贷在下一页预览合同
            if (!checkIsInstallment()) {
                const res = await previewContract(prodNo, contractKeysStore.contractKeysState.loanProduct, true);
                if (!res) {
                    return -1;
                }
            }
            // 跳转去问卷可能需要点时间 加个loadin自动消失
            showLoading(true, '', 1000);
            await goToQuestion(productStore.productState);
            return 0;
        }
        catch (err) {
            showLoading(false);
            console.error({ err });
            const error = err;
            // 不在特斯拉白名单内
            if (error.code === NOT_IN_TESLAWHITELIST) {
                return error.code;
            }
            // 用户没有香港身份证
            if (error.code === NO_HONGKONG_IDCARD) {
                showModal(productConfig.config.applyTips.split('\n'), $t('暂不符合以下之申请资格'), '', $t('我知道了'));
                return error.code;
            }
            // 用户手动拒绝额度，1038850145（未接受），1038850146（取消）和1038850152（确认超时）
            if (error.code === 1038850145 || error.code === 1038850146 || error.code === 1038850152) {
                showCancelTips(error.extInfo);
                return error.code;
            }
            showModalError(error.message, error.code, $t('确认'));
        }
    };
    // 判断如果有tesila车架号工单或者审核中给个弹窗提示
    async function checkTeslaOwnerInfo() {
        if (isTesla) {
            try {
                const checkOwnerInfo = await checkTeslaWhiteAndOwnerInfo();
                if (!checkOwnerInfo.isInTeslaWhite && [
                    EnumWhitelistStatus.WHITELIST_STATUS_TOCONFIRM,
                    EnumWhitelistStatus.WHITELIST_STATUS_TO_APPROVE
                ].includes(checkOwnerInfo.whitelistStatus.low)) {
                    showModal($t('您的车辆信息正在核实中，可继续申请贷款。如车辆信息未能确认，或须递交车主证明。'), '', '', '');
                    await sleep(3000);
                    hideModal();
                }
            }
            catch (error) {
                throw error;
            }
        }
    }
    return {
        state,
        submitApply,
    };
}
